import { Search} from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Chip, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import {InputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance,  DialogType,  FormActions, usuarioEntity } from "../../utils/constants";
import * as yup from "yup";




const schema = yup.object({
  usuario: yup.string().required(),
  razon_social: yup.string().required(),
  celular: yup.number().required(),
  email: yup.string().email().required(),
  pass: yup.string().optional(),
  perfil: yup.number().required(),
  productos_asociados: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional(),
  centro_op_destinos: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional().notRequired().nullable(),
  activo: yup.bool().required(),
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestrosCondicionesPagos = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...usuarioEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [roles,setRoles] = useState([]);
  const [productosOptions,setProductosOptions] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [centrosOp,setCentrosOp] = useState([]);
  const [centrosOpDestino,setCentrosOpDestino] = useState([]);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }

    const loadCentrosOp = async(search)=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
      return value;
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros-marketplace/condiciones-pagos",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

  
    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }


    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
   }



  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"descripcion",
        keyValue:"descripcion",
        label:"Nombre",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"Codigo erp",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      
       
       
     
    ];
   

    return (<>
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar proceso"
            
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
      
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info ={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}